import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';

import type { PrimeSitePropertiesQuery } from '@/generated/graphql';
import PRIME_SITE_PROPERTIES from '@/clientState/providers/operations/primeProperties';

const usePrimeSiteProperties = (): UseQueryResult<PrimeSitePropertiesQuery> => {
  return useQuery<PrimeSitePropertiesQuery>(PRIME_SITE_PROPERTIES, {});
};

export default usePrimeSiteProperties;
